import script from "./RenovarMatriculaBrinde.vue?vue&type=script&setup=true&lang=js"
export * from "./RenovarMatriculaBrinde.vue?vue&type=script&setup=true&lang=js"

import "./RenovarMatriculaBrinde.vue?vue&type=style&index=0&id=2b219098&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b219098"]])

export default __exports__